import { getRequestHeaders } from "./getRequestHeaders";
import { makeUrl } from "./makeUrl";
import { handleResponse } from "./response";

async function getAdjustedHeaders(useTurnstile: boolean | undefined) {
    const headers = getRequestHeaders();
    if (useTurnstile) {
        const token = await (window as any).CareEv?.WaitForClientVerificationToken();
        if (token) {
            headers.append("clientverificationtoken", token);
            headers.append("clientverificationtype", "turnstile");
        }
    }
    return headers;
}

/***
 * Returns the response payload. All error responses are translated into an Error object
 * with a user-presentable message.
 */
 export async function getRequest(path: string, queryParameters?: URLSearchParams, clientVerificationRequired?: boolean) {
    if (queryParameters && path.includes("?")) {
        throw new Error("Query parameters cannot be passed in both the path and the queryParameters parameter.");
    }

    if (queryParameters) {
        const searchString = queryParameters.toString();
        if (searchString) {
            path += `?${searchString}`;
        }
    }

    return fetch(makeUrl(path), {
        method: 'GET',
        headers: await getAdjustedHeaders(clientVerificationRequired),
    }).then(response => handleResponse(response));
}

/***
 * Returns the response payload. All error responses are translated into an Error object
 * with a user-presentable message.
 */
export async function postRequest(path: string, data: any, clientVerificationRequired?: boolean) {
    return fetch(makeUrl(path), {
        method: 'POST',
        headers: await getAdjustedHeaders(clientVerificationRequired),
        body: JSON.stringify(data)
    }).then(response => handleResponse(response));
}

/***
 * Returns the response payload. All error responses are translated into an Error object
 * with a user-presentable message.
 */
export function putRequest(path: string, data: any) {
    return fetch(makeUrl(path), {
        method: 'PUT',
        headers: getRequestHeaders(),
        body: JSON.stringify(data)
    }).then(response => handleResponse(response));
}

/***
 * Returns the response payload. All error responses are translated into an Error object
 * with a user-presentable message.
 */
export function deleteRequest(path: string) {
    return fetch(makeUrl(path), {
        method: 'DELETE',
        headers: getRequestHeaders()
    }).then(response => handleResponse(response));
}

export function createSearchParams(queryParameters: object): URLSearchParams {
    const searchParameters = new URLSearchParams();
    for (const [k, v] of Object.entries(queryParameters)) {
        if (!v) {
            continue;
        }
        searchParameters.append(k, v.toString());
    }
    return searchParameters;
}